import { Text } from '@/components/Typographies/Text/Text';
import { Title } from '@/components/Typographies/Title/Title';
import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <div className="flex size-full flex-col items-center justify-center gap-6 p-4 md:p-8 max-w-4xl">
      <img
        src="/not_found.jpg"
        alt="404 not found"
        className="md:w-full h-52 object-[25%_77%] object-cover aspect-video"
      />
      <Title level={4} className="text-2xl">
        Une erreur est survenue, veuillez recommencer
      </Title>
      <Text className="text-base">
        Nous sommes désolés, une erreur est survenue. Réessayez plus tard ou
        bien retournez à l’accueil.
      </Text>
      <Link
        to="/"
        className="bg-primary text-primary-foreground shadow-xs hover:bg-primary/90 h-9 px-4 py-2 font-eurostile rounded-md text-sm font-medium"
      >
        Retour à l’accueil
      </Link>
    </div>
  );
}
